var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// libs
import React, { memo } from 'react';
// HOC
import withIconDefaults from './withIconDefaults';
function IconHome(_a) {
    var { fillColor } = _a, props = __rest(_a, ["fillColor"]);
    return (React.createElement("svg", Object.assign({ width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { id: "home_FILL0_wght400_GRAD0_opsz48 (2) 1" },
            React.createElement("path", { id: "Vector", d: "M4.88013 16.6426H8.00513V11.4343H12.5885V16.6426H15.7135V8.51764L10.2968 4.45514L4.88013 8.51764V16.6426ZM3.63013 17.8926V7.89264L10.2968 2.89264L16.9635 7.89264V17.8926H11.3385V12.6843H9.25513V17.8926H3.63013Z", fill: fillColor }))));
}
export default memo(withIconDefaults(IconHome));
